import { useContext, useState } from 'react';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';
import { useEffect } from 'react';


export function UpdateSectionRenewal({ setShowModal, getData, item }) {
  const {logOutFunction, userProfile} = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const {setTostMessage} = useContext(TostMessageContext);
  const [cookies] = useCookies();
  const [formFields, setFormFields] = useState({ member_no: item?.member_no, section_id: item?.section_id });

  useEffect(() => {
    console.log(item)
  }, [])
  const handleSubmit = async () => {
    const formData = new FormData();
    Object.entries(formFields).forEach(([key, value]) => {
        formData.append(key, value);
    });
    setLoading(true)
    try {
        const response = await axios.post(base_url + '/update-section-renewal.php', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                token: cookies?.userProfile?.session,
                memberno: cookies?.userProfile?.main_id,
            },
        });
        if (response.data.code == 403) {
            logOutFunction()
        }
        if (response.data.status) {
            setTostMessage({
                messageType: 'success',
                message: response.data.response
            })
            getData();
            setShowModal(false);
        } else {
        setTostMessage({
            messageType: 'error',
            message: response.data.response
        })
        }
        setLoading(false)
    } catch (error) {
        setLoading(false)
        setTostMessage({
            messageType: 'error',
            message: 'Network Error'
        })
    }
  };

  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div className='w-[80%] flex justify-end text-underline text-[#ff0000]'>
                    <p className='cursor-pointer' onClick={() => setShowModal(false)}>Cancel</p>
                </div>
                <a className='text-dark text-[17px] font-bold'>Update Section Renewal</a>
                <a className='text-dark text-[15px] font-regular'>{'Fill the form appropriately'}</a>
                    <div className='w-[80%] self-start mx-auto flex flex-col mt-2 gap-y-1'>
                        <label>Member Name</label>
                        <input readOnly value={item?.name} type='default' className="w-full border px-2 py-2 rounded text-sm md:text-[15px]" placeholder="Member Name" />
                    </div>
                    <div className='w-[80%] self-start mx-auto flex flex-col mt-2 gap-y-1'>
                        <label>New Renewal Period</label>
                        <input type='date' onChange={(e) => setFormFields({...formFields, renewal_date: e.target.value})} className="w-full border px-2 py-2 rounded text-sm md:text-[15px]" placeholder="Event Title" />
                    </div>
                    <div className="flex justify-between mt-5">
                        <button
                            onClick={handleSubmit}
                            className="
                            bg-[#000080] text-white rounded-full font-semibold
                            px-8 py-3 transition hover:bg-primary
                            w-full md:w-auto md:self-center
                            "
                        >
                            Renew Membership
                        </button>
                    </div>
                    {loading ? (
                        <ClockLoader
                            color={'#212121'}
                            loading={loading}
                            size={25}
                            className='mt-3'
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                        ) : null
                    }
            </div>  
        </div>
    )
}

